"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decimalNormalizer = exports.numberFormatter = void 0;
const _1 = require(".");
const numberFormatter = (percentage) => {
    if (isNaN(Number(percentage))) {
        return '-';
    }
    return (typeof percentage === 'number' ? percentage : parseFloat(percentage)).toLocaleString(_1.DEFAULT_LOCALE, _1.FORMAT_OPTIONS);
};
exports.numberFormatter = numberFormatter;
const decimalNormalizer = (value) => {
    var _a, _b, _c, _d, _e, _f;
    if (!((_a = value === null || value === void 0 ? void 0 : value.toString) === null || _a === void 0 ? void 0 : _a.call(value).includes(',')))
        return (_b = value === null || value === void 0 ? void 0 : value.toString) === null || _b === void 0 ? void 0 : _b.call(value);
    return (_f = (_e = (_d = (_c = (typeof value === 'number' ? value.toString() : value)) === null || _c === void 0 ? void 0 : _c.replace) === null || _d === void 0 ? void 0 : _d.call(_c, /\./g, '')) === null || _e === void 0 ? void 0 : _e.replace) === null || _f === void 0 ? void 0 : _f.call(_e, /,/g, '.');
};
exports.decimalNormalizer = decimalNormalizer;
